import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { SubstancePreviousNameCodeFields } from "../../../Data/Art57Data/SubstancePreviousNameCodeFields";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstancePreviousNameCodeFields extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new SubstancePreviousNameCodeFields(
          new FieldDefinition(injector)
        ),
        'Substance Name or Code'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Substance Name or Code';
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      let substanceText = '';
      let isText = '';
  
      if (this.data && this.data.model && this.data.model.substancename) {
        substanceText = this.data.model.substancename;
      }
  
      if (this.data && this.data.model && this.data.model.iscode) {
        isText = this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'substancenameorcode',
          this.data.model.iscode
        );
      }
  
      if (substanceText != '' && isText != '') {
        this.label = substanceText + ' - ' + isText;
      } else if (substanceText != '' || isText != '') {
        this.label = substanceText + isText; // only one of the is filled
      } else {
        this.label = this.labelTemplate;
      }
    }
  
    override getMessage(): any {
      if (this.data.model && Object.keys(this.data.model).length > 0) {
        return this.data.model;
      } else {
        return;
      }
    }
  
    override getListItem(): any[] {
      return [
        this.data.model && this.data.model.substancename
          ? this.data.model.substancename
          : 'Not selected',
        this.data.model && this.data.model.iscode
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
            'substancenameorcode',
            this.data.model.iscode
          )
          : 'Not selected',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeSubstancePreviousNameCodeFields =
        new TreeNodeSubstancePreviousNameCodeFields(this.ioc!, newParent);
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.refreshLabel();
  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];
      
      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }
  